import React, { useContext, useEffect } from 'react';
export const defaultPopupConfig = {
    len: 0,
    isPopupChildVisible: false,
    popups: {},
};
export const PopupContext = React.createContext(defaultPopupConfig);
export const usePopup = (props) => {
    const config = useContext(PopupContext);
    useEffect(() => {
        var _a, _b;
        (_a = config.onRegister) === null || _a === void 0 ? void 0 : _a.call(config, (_b = props === null || props === void 0 ? void 0 : props.id) === null || _b === void 0 ? void 0 : _b.current);
        return () => { var _a, _b; return (_a = config.onUnRegister) === null || _a === void 0 ? void 0 : _a.call(config, (_b = props === null || props === void 0 ? void 0 : props.id) === null || _b === void 0 ? void 0 : _b.current); };
    }, [config.onUnRegister, config.onRegister, props.id]);
    return config;
};
